<template>
  <Account
    class="v-login"
    :image-header1="$ucfirst($t('login.welcome', { catalog: 'local' }))"
    :image-header2="$ucfirst($t('login.continue', { catalog: 'local' }))"
    :image-url="$asset('image/login-stock2.jpg')"
    :image-aspect-ratio="1217 / 728"
    :versionInfo="$app.version"
    :break-after-logo="true"
  >
    <h1
      v-show="$vuetify.breakpoint.mdAndUp"
      class="v-login__signin text-h4 text-center font-family-futura"
    >
      {{ $capitalize($t(pageHeader, { catalog: "local" })) }}
    </h1>

    <v-form v-on:submit.prevent="tryLogin">
      <p v-if="loginData.errorMessage" class="color-coro-red">
        {{ $ucfirst($t(loginData.errorMessage, { catalog: "local" })) }}
      </p>
      <!-- <v-text-field
              v-model="centerToken"
              :label="$capitalize($t('login.centertoken', {catalog: 'local'}))"
              autocomplete="on"
              outlined
      ></v-text-field> -->
      <template v-if="!show2fa">
        <v-text-field
          v-model="username"
          :label="$capitalize($t('login.username', { catalog: 'local' }))"
          autocomplete="on"
          outlined
          name="username"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :label="$capitalize($t('login.password', { catalog: 'local' }))"
          autocomplete="on"
          outlined
          :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="() => (showPassword = !showPassword)"
          :type="showPassword ? 'text' : 'password'"
          name="password"
        ></v-text-field>
        <v-btn color="primary" type="submit" x-large block>
          {{ $capitalize($t("login.signin", { catalog: "local" })) }}
        </v-btn>
        <a
          v-if="!show2fa"
          :href="`${BASE_URL}/forgot-password`"
          class="inline-stretch text-center secondary--text text-decoration-underline v-login__forgotpassword"
          target="_blank"
        >
          {{ $ucfirst($t("login.reset.forgot", { catalog: "local" })) }}
        </a>
      </template>
      <template v-if="show2fa">
        <v-text-field
          v-model="code"
          :label="$capitalize($t('login.code', { catalog: 'local' }))"
          autocomplete="off"
          maxlength="6"
          outlined
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
        ></v-text-field>
        <v-btn
          color="primary"
          type="submit"
          x-large
          block
          :disabled="!codeFormatValid"
        >
          {{ $capitalize($t("login.signin", { catalog: "local" })) }}
        </v-btn>
        <p
          class="v-login__back inline-stretch text-center secondary--text text-decoration-underline"
          v-if="show2fa"
          v-on:click="resetLoginForm"
        >
          {{ $ucfirst($t("login.backtologin", { catalog: "local" })) }}
        </p>
      </template>
    </v-form>
  </Account>
</template>

<script>
import Account from "../../components/Account/Account";
import {ROLE_CASE_NURSE, ROLE_REPORTS} from "../../../store/user/role-tree";

/**
 * Component Login.vue
 *
 * @module Login
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/views/Account/Login.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "Login",
  components: {
    Account,
  },
  methods: {
    tryLogin: function () {
      this.$app.authentication
        .login(this.centerToken, this.username, this.password, this.code)
        .then((loginData) => {
          this.loginData = loginData;

          if (loginData.tfa_required) {
            this.code = null;
            this.show2fa = true;
          }

          if (loginData.success) {
            // // Refresh translations
            this.$app.translationManager
              .loadLanguages(["en", this.$store.state.currentLanguage])
              .then(() => {
                // workaround alerts title not being set
                const setTitleInterval = setInterval(() => {
                  if (
                    this.$app.translationManager.isCatalogLoaded(
                      "app_dashboard",
                      "en"
                    )
                  ) {
                    this.$toasted.show(
                      this.$t("login.loggedin", { catalog: "local" })
                    );
                    if (
                        this.$store.getters["user/isGranted"](ROLE_REPORTS) &&
                        !this.$store.getters["user/isGranted"](ROLE_CASE_NURSE)
                    ) {
                      this.$router.push({ name: "Reports" });
                    } else {
                      this.$router.push({ name: "Alerts" });
                    }

                    clearInterval(setTitleInterval);
                  }
                }, 100);
              });
          } else {
            if (loginData.errorMessage)
              this.$toasted.error(
                this.$ucfirst(
                  this.$t(loginData.errorMessage, { catalog: "local" })
                )
              );
          }
        });
    },
    resetLoginForm() {
      this.username = this.password = this.code = null;
      this.show2fa = false;
      this.loginData = {};
    },
  },
  computed: {
    codeFormatValid: function () {
      return this.code && this.code.length === 6;
    },
    pageHeader: function () {
      return this.show2fa ? "login.entercode" : "login.signin";
    },
    BASE_URL() {
      return process.env.VUE_APP_URL_EDC;
    },
  },
  data: () => ({
    centerToken: "",
    username: "",
    password: "",
    loginData: {},
    showPassword: false,
    show2fa: false,
    code: null,
  }),
};
</script>

<style lang="scss">
// mobile first
.v-login__signin {
  margin: 50px 0 76px 0;
}

.v-login__back,
.v-login__forgotpassword {
  margin-top: 20px;
  cursor: pointer;
}
</style>
